const textKorporasi = {
	TENAGA_KESEHATAN: {
		PAGE_GREETING: 'Mitra Korporasi',
		PAGE_GREETING_DESC: 'Silakan lengkapi data berikut dan sertakan tujuan kerja sama',
	},
	ALPHABET: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
};

export default textKorporasi;
